import controller from './controller';
import view from './view.html';

/* @ngInject */
export default function ($stateProvider) {
	$stateProvider
		.state('splash.home', {
			url:        '/splash',
			template:   view,
			controller: controller,
		});
};


// WEBPACK FOOTER //
// ./src/js/endpoints/splash/home/router.js